import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
import ScrollAnim from '@/directives/scrollAnim'
import VueGtag from "vue-gtag";

const app = createApp(App)
app.config.globalProperties.$getImgUrl = (path)=> {
  if (process.env.NODE_ENV === 'production'){
    return `https://plus-file.creators.ogq.me${path.replace('assets', '')}`
  } else {
    return require(`@/${path}`)
  }
}
app.directive('scrollanim', ScrollAnim)
app.use(store)
app.use(VueGtag, {
  config: { id: 'G-KYQ875PC75' }
})
app.mount('#app')
